import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RestaurantOrder, RestaurantOrderCreate, RestaurantOrderFilter } from '../data/restaurantOrder';

export function createRestaurantOrderService(client: AxiosInstance) {
  return createCrudService<RestaurantOrder, RestaurantOrderCreate, RestaurantOrderFilter>(
    client,
    '/restaurant/RestaurantOrder',
    'id',
  );
}

export type RestaurantOrderService = CrudService<RestaurantOrder, RestaurantOrderCreate, RestaurantOrderFilter>;
